
//vi|en|ko|my|id|th 
export enum LanguageCode {
    vi = 'vi',
    en = 'en',
    ko = 'ko',
    my = 'my',
    id = 'id',
    th = 'th',
    ja = 'ja',
    zh = 'zh',
    de = 'de',
    hi = 'hi',
    fr = 'fr',
}

export const LANG_CODE: string[] = [
    LanguageCode.vi,
    LanguageCode.en,
    LanguageCode.ko,
    LanguageCode.my,
    LanguageCode.id,
    LanguageCode.th,
    LanguageCode.ja,
    LanguageCode.zh,
    LanguageCode.de,
    LanguageCode.hi,
    LanguageCode.fr,
]

export enum TypeUserLogin {
    NORMAL = 'normal',
    SNS = 'sns',
}
export const TYPE_USER_LOGIN: string[] = [
    TypeUserLogin.NORMAL,
    TypeUserLogin.SNS,
]

export enum TypeShareSns {
    IN_APP = 'IN_APP',
    FACEBOOK = 'FACEBOOK',
    INSTAGRAM = 'INSTAGRAM',
    KAKAOTALK = 'KAKAOTALK',
}
export const TYPE_SHARE_SNS: string[] = [
    TypeShareSns.IN_APP,
    TypeShareSns.FACEBOOK,
    TypeShareSns.INSTAGRAM,
    TypeShareSns.KAKAOTALK,
]